<template>
  <div class="widget-gender">
    <button
      :class="value === MALE ? 'btn-checked' : 'btn-disable'"
      class="btn-custom"
      @click="$emit('input', MALE)"
    >
      {{ $t('register-page.btn-gender.male', { split: '/' }) }}
    </button>
    <button
      :class="value === FEMALE ? 'btn-checked' : 'btn-disable'"
      class="btn-custom btn-female"
      @click="$emit('input', FEMALE)"
    >
      {{ $t('register-page.btn-gender.female', { split: '/' }) }}
    </button>
    <button
      :class="value === OTHER ? 'btn-checked' : 'btn-disable'"
      class="btn-custom btn-female"
      @click="$emit('input', OTHER)"
    >
      {{ $t('register-page.btn-gender.other', { split: '/' }) }}
    </button>
  </div>
</template>

<script>
import { MALE, FEMALE, OTHER } from '@/common/constants';

export default {
  name: 'GenderSelector',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      MALE,
      FEMALE,
      OTHER
    };
  }
};
</script>
